export default "__VITE_ASSET__CzWaMSPg__"